<template>
  <div class="mediakit-settings">
    <h2 class="headline">Media Kit page settings</h2>

    <v-form class="form">
      <v-layout>
        <v-flex class="input" xs3>
          <content-editor
            label="Page title"
            v-model="mediaKitsSetting.title"
            :error="$v.mediaKitsSetting.title"
            @input="$v.mediaKitsSetting.title.$touch()"
            @blur="$v.mediaKitsSetting.title.$touch()"
          />
        </v-flex>
        <v-flex class="input" xs3 offset-xs1>
          <content-editor
            label="Page Subtitle"
            v-model="mediaKitsSetting.subtitle"
            :error="$v.mediaKitsSetting.subtitle"
            @input="$v.mediaKitsSetting.subtitle.$touch()"
            @blur="$v.mediaKitsSetting.subtitle.$touch()"
          />
        </v-flex>
        <v-flex class="input" xs3 offset-xs1>
          <content-editor
            label="Button text"
            v-model="mediaKitsSetting.submitButtonText"
            :error="$v.mediaKitsSetting.submitButtonText"
            @input="$v.mediaKitsSetting.submitButtonText.$touch()"
            @blur="$v.mediaKitsSetting.submitButtonText.$touch()"
          />
        </v-flex>
      </v-layout>
      <e-color-picker
        label="button background color"
        :v-model="mediaKitsSetting.submitButtonColor"
        :value="{'hex':mediaKitsSetting.submitButtonColor}"
        @colorChange="onBackgroundButtonColorChange"
      />
      <e-color-picker
        label="button background hover color"
        :v-model="mediaKitsSetting.submitButtonHoverColor"
        :value="{'hex':mediaKitsSetting.submitButtonHoverColor}"
        @colorChange="onBackgroundHoverButtonColorChange"
      />
      <content-field
        label="First Name Placeholder"
        v-model="mediaKitsSetting.firstNamePlaceholder"
        :error="$v.mediaKitsSetting.firstNamePlaceholder"
        @input="$v.mediaKitsSetting.firstNamePlaceholder.$touch()"
        @blur="$v.mediaKitsSetting.firstNamePlaceholder.$touch()"
      />
      <content-field
        label="Last Name Placeholder"
        v-model="mediaKitsSetting.lastNamePlaceholder"
        :error="$v.mediaKitsSetting.lastNamePlaceholder"
        @input="$v.mediaKitsSetting.lastNamePlaceholder.$touch()"
        @blur="$v.mediaKitsSetting.lastNamePlaceholder.$touch()"
      />
      <content-field
        label="Email Placeholder"
        v-model="mediaKitsSetting.emailPlaceholder"
        :error="$v.mediaKitsSetting.emailPlaceholder"
        @input="$v.mediaKitsSetting.emailPlaceholder.$touch()"
        @blur="$v.mediaKitsSetting.emailPlaceholder.$touch()"
      />
      <content-field
        label="Filter Placeholder"
        v-model="mediaKitsSetting.filterPlaceholder"
        :error="$v.mediaKitsSetting.filterPlaceholder"
        @input="$v.mediaKitsSetting.filterPlaceholder.$touch()"
        @blur="$v.mediaKitsSetting.filterPlaceholder.$touch()"
      />
      <v-btn
        class="btn_submit"
        color="success"
        @click="submitForm"
        :disabled="$v.$invalid"
      >Update settings
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { path, pathOr, clone } from 'ramda'
import EColorPicker from '@/components/shared/EColorPicker'

export default {
  name: 'media-kit-settings',
  components: {
    EColorPicker
  },
  data () {
    return {
      mediaKitsSetting: {
        title: '',
        subtitle: '',
        submitButtonColor: '',
        submitButtonHoverColor: '',
        submitButtonText: '',
        firstNamePlaceholder: '',
        lastNamePlaceholder: '',
        emailPlaceholder: '',
        filterPlaceholder: ''
      }
    }
  },
  validations: {
    mediaKitsSetting: {
      title: { required },
      subtitle: { required },
      submitButtonColor: { required },
      submitButtonHoverColor: { required },
      submitButtonText: { required },
      firstNamePlaceholder: { required },
      lastNamePlaceholder: { required },
      emailPlaceholder: { required },
      filterPlaceholder: { required }
    }
  },
  computed: {
    ...mapGetters(['getSettings']),
    getMediaKitsSetting () {
      return pathOr(null, ['mediaKitsSetting'], this.getSettings)
    }
  },
  watch: {
    getMediaKitsSetting: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.setFormData()
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'updateMediaKitsSettings',
      'fetchGeneralSettings'
    ]),
    path,
    clone,
    setFormData () {
      if (this.getMediaKitsSetting) {
        this.mediaKitsSetting = clone(this.getMediaKitsSetting)
      }
    },
    submitForm () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.updateMediaKitsSettings(this.mediaKitsSetting)
    },
    onBackgroundButtonColorChange (newColor) {
      this.mediaKitsSetting.submitButtonColor = newColor.hex
    },
    onBackgroundHoverButtonColorChange (newColor) {
      this.mediaKitsSetting.submitButtonHoverColor = newColor.hex
    }
  }
}
</script>

<style lang="scss" scoped>
.mediakit-settings {
  min-height: 92vh;
}

/deep/ .jodit_sticky .jodit_toolbar {
  position: static !important;
}

.input,
.headline {
  max-width: 480px;
}

.input:first-child {
  margin-right: 10px;
}

.headline {
  margin-bottom: 20px;
  text-align: left;
}

.card {
  padding: 10px;
  margin-bottom: 15px;
}

.btn {
  &_submit {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/Settings/MediaKitSettings/index.vue